import React, { useEffect, useRef, useState } from 'react';
import { canUseWebP, getConvertedImageFarmUrl, ImageFarmParamsType } from '@croquiscom-pvt/utils';
import { ImageLoader } from 'next/image';

import { useOnceReveal } from '@common/hooks';

interface useEpickStylistItemCardProps {
  onImpressionItemCard: () => void;
}

export const useEpickStylistItemCard = ({ onImpressionItemCard }: useEpickStylistItemCardProps) => {
  const { targetRef, isRevealed } = useOnceReveal({ threshold: 0.1 });

  const img_placeholder_ref = useRef<HTMLDivElement>(null);
  const [is_display_image, setIsDisplayImage] = useState(false);

  const placeholder_display_style = is_display_image ? 'none' : 'block';

  useEffect(() => {
    if (isRevealed) {
      onImpressionItemCard();
      setIsDisplayImage(true);
    }
  }, [isRevealed]);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    (e.target as HTMLImageElement).classList.add('error');
    img_placeholder_ref.current?.classList.add('show');
  };

  const myLoader: ImageLoader = ({ src, width, quality }) => {
    const options: ImageFarmParamsType = { width: width, quality: quality || 75 };

    if (canUseWebP) {
      options['format'] = 'webp';
    }
    return getConvertedImageFarmUrl(src, options);
  };

  return {
    impression_target_ref: targetRef,
    img_placeholder_ref,
    is_display_image,
    placeholder_display_style,
    myLoader,
    handleError,
  };
};
